/**
 * @generated SignedSource<<dc56089c95a80bce8cc1029df5a9ab63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NotificationsPreferencesQuery$variables = {};
export type NotificationsPreferencesQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly office365: {
        readonly id: string;
      } | null;
    };
    readonly settings: {
      readonly commentsNotifyReplyResolve: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly commentsNotifyWatchedStreams: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly digest1on1sEnabled: boolean | null;
      readonly digestEmailFrequency: string | null;
      readonly digestMeetingsEnabled: boolean | null;
      readonly digestObjectivesEnabled: boolean | null;
      readonly digestSlackFrequency: string | null;
      readonly digestTeamsFrequency: string | null;
      readonly emailNotificationsEnabled: boolean | null;
      readonly feedbackGivenToMeEmailEnabled: boolean;
      readonly feedbackGivenToMeSlackEnabled: boolean;
      readonly feedbackGivenToMeTeamsEnabled: boolean;
      readonly feedbackNeedsActionEmailEnabled: boolean;
      readonly feedbackNeedsActionSlackEnabled: boolean;
      readonly feedbackNeedsActionTeamsEnabled: boolean;
      readonly feedbackRequestIHaveSentEmailEnabled: boolean;
      readonly feedbackRequestIHaveSentSlackEnabled: boolean;
      readonly feedbackRequestIHaveSentTeamsEnabled: boolean;
      readonly feedbackSharedWithMeEmailEnabled: boolean;
      readonly feedbackSharedWithMeSlackEnabled: boolean;
      readonly feedbackSharedWithMeTeamsEnabled: boolean;
      readonly feedbackSummaryForMeetingsIHostEmailEnabled: boolean;
      readonly feedbackSummaryForMeetingsIHostSlackEnabled: boolean;
      readonly feedbackSummaryForMeetingsIHostTeamsEnabled: boolean;
      readonly impending1on1NotificationDeliveryPathways: ReadonlyArray<string | null> | null;
      readonly impending1on1NotificationDeliveryTimeUnit: string | null;
      readonly impending1on1NotificationDeliveryTimeValue: number | null;
      readonly impending1on1NotificationMeetingsWhitelist: ReadonlyArray<{
        readonly end: string | null;
        readonly guid: string;
        readonly id: string;
        readonly start: string | null;
        readonly title: string;
      }>;
      readonly impendingOkrDueDateNotificationDeliveryTimeUnit: string | null;
      readonly impendingOkrDueDateNotificationDeliveryTimeValue: number | null;
      readonly impendingOkrDueDateNotificationEnabled: boolean | null;
      readonly meetingBriefsNotifyReady: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly meetingRecordingAvailableNotificationEnabled: boolean | null;
      readonly notifyAboutAssignment: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly notifyAboutChannelsIJoined: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly notifyAboutDueDateChange: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly notifyAboutMention: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly notifyAboutNoteEdited: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly notifyAboutPostsInChannelsIWatch: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly notifyAboutRecordingsFirstViewed: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly notifyAboutTalkingPoint: {
        readonly email: boolean;
        readonly push: boolean;
      };
      readonly objectivesNotifyAssigned: boolean | null;
      readonly objectivesNotifyEndOfCycleReminder: boolean | null;
      readonly objectivesNotifyUpdated: boolean | null;
      readonly promptNotificationsSendViaEmail: boolean | null;
      readonly promptNotificationsSendViaSlack: boolean | null;
      readonly promptNotificationsSendViaTeams: boolean | null;
      readonly pushNotificationsEnabled: boolean | null;
      readonly slackNotificationsEnabled: boolean | null;
      readonly teamsNotificationsEnabled: boolean | null;
    };
    readonly user: {
      readonly account: {
        readonly allowAiFeatures: boolean;
      };
      readonly internalAttributes: {
        readonly isUnsubscribedFromEmails: boolean;
        readonly manageEmailsUrl: string;
      } | null;
    };
  };
};
export type NotificationsPreferencesQuery = {
  response: NotificationsPreferencesQuery$data;
  variables: NotificationsPreferencesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "UserIntegrations",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OfficeUserNode",
      "kind": "LinkedField",
      "name": "office365",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "push",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pushNotificationsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailNotificationsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slackNotificationsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamsNotificationsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "digestObjectivesEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "digestMeetingsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "digest1on1sEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "digestEmailFrequency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "digestSlackFrequency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "digestTeamsFrequency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "notifyAboutMention",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "notifyAboutAssignment",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "notifyAboutTalkingPoint",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "notifyAboutDueDateChange",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "notifyAboutNoteEdited",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "notifyAboutRecordingsFirstViewed",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordingAvailableNotificationEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "notifyAboutChannelsIJoined",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "notifyAboutPostsInChannelsIWatch",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "commentsNotifyWatchedStreams",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "commentsNotifyReplyResolve",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActivityNotificationPreference",
      "kind": "LinkedField",
      "name": "meetingBriefsNotifyReady",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impending1on1NotificationDeliveryPathways",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impending1on1NotificationDeliveryTimeUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impending1on1NotificationDeliveryTimeValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "impending1on1NotificationMeetingsWhitelist",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "guid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "objectivesNotifyAssigned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "objectivesNotifyUpdated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "objectivesNotifyEndOfCycleReminder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impendingOkrDueDateNotificationEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impendingOkrDueDateNotificationDeliveryTimeUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impendingOkrDueDateNotificationDeliveryTimeValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "promptNotificationsSendViaSlack",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "promptNotificationsSendViaTeams",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "promptNotificationsSendViaEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackSummaryForMeetingsIHostEmailEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackGivenToMeEmailEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackSharedWithMeEmailEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackNeedsActionEmailEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackRequestIHaveSentEmailEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackSummaryForMeetingsIHostSlackEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackGivenToMeSlackEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackSharedWithMeSlackEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackNeedsActionSlackEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackRequestIHaveSentSlackEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackSummaryForMeetingsIHostTeamsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackGivenToMeTeamsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackSharedWithMeTeamsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackNeedsActionTeamsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackRequestIHaveSentTeamsEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUnsubscribedFromEmails",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manageEmailsUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowAiFeatures",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsPreferencesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationsPreferencesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9404a7a7a9b26c0553162802bb3ef4b7",
    "id": null,
    "metadata": {},
    "name": "NotificationsPreferencesQuery",
    "operationKind": "query",
    "text": "query NotificationsPreferencesQuery {\n  viewer {\n    integrations {\n      office365 {\n        id\n      }\n    }\n    settings {\n      pushNotificationsEnabled\n      emailNotificationsEnabled\n      slackNotificationsEnabled\n      teamsNotificationsEnabled\n      digestObjectivesEnabled\n      digestMeetingsEnabled\n      digest1on1sEnabled\n      digestEmailFrequency\n      digestSlackFrequency\n      digestTeamsFrequency\n      notifyAboutMention {\n        email\n        push\n      }\n      notifyAboutAssignment {\n        email\n        push\n      }\n      notifyAboutTalkingPoint {\n        email\n        push\n      }\n      notifyAboutDueDateChange {\n        email\n        push\n      }\n      notifyAboutNoteEdited {\n        email\n        push\n      }\n      notifyAboutRecordingsFirstViewed {\n        email\n        push\n      }\n      meetingRecordingAvailableNotificationEnabled\n      notifyAboutChannelsIJoined {\n        email\n        push\n      }\n      notifyAboutPostsInChannelsIWatch {\n        email\n        push\n      }\n      commentsNotifyWatchedStreams {\n        email\n        push\n      }\n      commentsNotifyReplyResolve {\n        email\n        push\n      }\n      meetingBriefsNotifyReady {\n        email\n        push\n      }\n      impending1on1NotificationDeliveryPathways\n      impending1on1NotificationDeliveryTimeUnit\n      impending1on1NotificationDeliveryTimeValue\n      impending1on1NotificationMeetingsWhitelist {\n        id\n        guid\n        title\n        start\n        end\n      }\n      objectivesNotifyAssigned\n      objectivesNotifyUpdated\n      objectivesNotifyEndOfCycleReminder\n      impendingOkrDueDateNotificationEnabled\n      impendingOkrDueDateNotificationDeliveryTimeUnit\n      impendingOkrDueDateNotificationDeliveryTimeValue\n      promptNotificationsSendViaSlack\n      promptNotificationsSendViaTeams\n      promptNotificationsSendViaEmail\n      feedbackSummaryForMeetingsIHostEmailEnabled\n      feedbackGivenToMeEmailEnabled\n      feedbackSharedWithMeEmailEnabled\n      feedbackNeedsActionEmailEnabled\n      feedbackRequestIHaveSentEmailEnabled\n      feedbackSummaryForMeetingsIHostSlackEnabled\n      feedbackGivenToMeSlackEnabled\n      feedbackSharedWithMeSlackEnabled\n      feedbackNeedsActionSlackEnabled\n      feedbackRequestIHaveSentSlackEnabled\n      feedbackSummaryForMeetingsIHostTeamsEnabled\n      feedbackGivenToMeTeamsEnabled\n      feedbackSharedWithMeTeamsEnabled\n      feedbackNeedsActionTeamsEnabled\n      feedbackRequestIHaveSentTeamsEnabled\n    }\n    user {\n      internalAttributes {\n        isUnsubscribedFromEmails\n        manageEmailsUrl\n        id\n      }\n      account {\n        __typename\n        allowAiFeatures\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8adff497afc99978892ca45f2d682b32";

export default node;
